import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { ApplyButton } from "@/components/site/AdmissionBadge";

export function MissedAdmission() {
  return (
    <section
      className="relative overflow-hidden py-20 sm:py-28"
      style={{ background: "linear-gradient(135deg,#EAF2FD 0%,#DBE8FA 60%,#CFE0F7 100%)" }}
      data-testid="missed-admission-section"
    >
      <div className="absolute -right-24 -top-24 h-80 w-80 rounded-full bg-[#0A1E4E]/5" />
      <div className="absolute -left-24 -bottom-24 h-80 w-80 rounded-full bg-[#16347A]/10" />
      <div className="container-x relative max-w-4xl">
        <motion.span
          initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }}
          className="block text-lg sm:text-2xl font-bold uppercase tracking-[0.25em] text-[#C0202A]"
        >
          Did You Miss University Admission?
        </motion.span>
        <motion.h2
          initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.05] text-[#0A1E4E]"
        >
          Delay is not denial.
        </motion.h2>
        <div className="mt-8 space-y-2 text-lg text-slate-700 max-w-2xl">
          <p>Did UTME not go as planned? Did you miss your preferred course? Did you fail to secure university admission?</p>
          <p className="font-bold text-[#16347A]">Your university dream is not over.</p>
          <p>
            The School of Basic Studies provides another structured pathway for eligible candidates who are ready
            to continue their academic journey.
          </p>
        </div>
        <ApplyButton className="btn-apply-bright mt-10 w-full !py-6 !text-xl sm:!text-2xl !tracking-widest" testId="missed-explore-options">
          Apply Now <ArrowRight size={26} />
        </ApplyButton>
      </div>
    </section>
  );
}
